import { render, staticRenderFns } from "./SfAddToCart.vue?vue&type=template&id=35f127b7&"
import script from "./SfAddToCart.vue?vue&type=script&lang=js&"
export * from "./SfAddToCart.vue?vue&type=script&lang=js&"
import style0 from "./SfAddToCart.vue?vue&type=style&index=0&id=35f127b7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports